<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #233076" class="font-weight-bold">
          {{ $t("SIDENAV.settings.dashboard_settings") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #233076">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="6"
            identifier="header_image"
            :acceptVideo="true"
            :preSelectedImage="data.header_image.path"
            :placeholder="$t('PLACEHOLDERS.header_image')"
            @selectImage="selectHeaderImage"
          />

          <base-image-upload-input
            col="6"
            identifier="about_image"
            :preSelectedImage="data.about_image.path"
            :placeholder="$t('PLACEHOLDERS.about_image')"
            @selectImage="selectAboutImage"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.header_title_ar')"
            v-model.trim="data.value.header_title_ar"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.header_title_en')"
            v-model.trim="data.value.header_title_en"
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.header_description_ar')"
            v-model="data.value.header_description_ar"
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.header_description_en')"
            v-model="data.value.header_description_en"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.year_experience')"
            v-model.trim="data.value.year_experience"
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.successful_cases')"
            v-model.trim="data.value.successful_cases"
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.follow_up_of_patients')"
            v-model.trim="data.value.follow_up_of_patients"
          />
          <!-- <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.degree_of_security')"
            v-model.trim="data.value.degree_of_security"
          /> -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.years_of_practice')"
            v-model.trim="data.value.years_of_practice"
          />
          <!-- <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.success_rate')"
            v-model.trim="data.value.success_rate"
          /> -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.about_title_ar')"
            v-model.trim="data.value.about_title_ar"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.about_title_en')"
            v-model.trim="data.value.about_title_en"
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.about_description_ar')"
            v-model="data.value.about_description_ar"
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.about_description_en')"
            v-model="data.value.about_description_en"
          />

          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.doctor_page_ar')"
            v-model="data.value.doctor_page_ar"
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.doctor_page_en')"
            v-model="data.value.doctor_page_en"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.youtube')"
            v-model.trim="data.value.youtube"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook')"
            v-model.trim="data.value.facebook"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.value.instagram"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok')"
            v-model.trim="data.value.tiktok"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.linkedin')"
            v-model.trim="data.value.linkedin"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.whatsapp')"
            v-model.trim="data.value.whatsapp"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.spotify')"
            v-model.trim="data.value.spotify"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.site_url')"
            v-model.trim="data.value.site_url"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.google_tag_manager_id')"
            v-model.trim="data.value.google_tag_manager_id"
          />
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.seo_header_code')"
            v-model="data.value.seo_header_code"
          />
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.tag_manager_head_code')"
            v-model="data.value.tag_manager_head_code"
          />
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.tag_manager_body_code')"
            v-model="data.value.tag_manager_body_code"
          />
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.robots_txt')"
            v-model="data.value.robots_txt"
          />
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.sitemap_xml')"
            v-model="data.value.sitemap_xml"
          />
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.sitemap_urls')"
            v-model="data.value.sitemap_urls"
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardSettings",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        key: "dashboard_setting",
        header_image: {
          path: null,
          file: null,
        },
        about_image: {
          path: null,
          file: null,
        },
        value: {
          header_title_ar: null,
          header_title_en: null,
          header_description_ar: null,
          header_description_en: null,
          year_experience: null,
          successful_cases: null,
          follow_up_of_patients: null,
          degree_of_security: null,
          years_of_practice: null,
          success_rate: null,
          about_title_ar: null,
          about_title_en: null,
          about_description_ar: null,
          about_description_en: null,
          youtube: null,
          facebook: null,
          instagram: null,
          tiktok: null,
          linkedin: null,
          whatsapp: null,
          spotify: null,
          site_url: null,
          google_tag_manager_id: null,
          seo_header_code: null,
          tag_manager_head_code: null,
          tag_manager_body_code: null,
          robots_txt: null,
          sitemap_xml: null,
          sitemap_urls: null,
          doctor_page_ar: null,
          doctor_page_en: null,
        },
      },
    };
  },

  methods: {
    selectHeaderImage(selectedImage) {
      this.data.header_image = selectedImage;
    },

    selectAboutImage(selectedImage) {
      this.data.about_image = selectedImage;
    },

    async getDataToEdit() {
      try {
        const res = await this.$axios.get(
          "settings-general?key=dashboard_setting"
        );
        const settings = res.data?.data?.data?.[0] || {};
        const value = settings.value || {};

        this.data.header_image.path = settings.header_image || null;
        this.data.about_image.path = settings.about_image || null;

        this.data.value.header_title_ar = value.header_title_ar || null;
        this.data.value.header_title_en = value.header_title_en || null;
        this.data.value.header_description_ar =
          value.header_description_ar || null;
        this.data.value.header_description_en =
          value.header_description_en || null;
        this.data.value.year_experience = value.year_experience || null;
        this.data.value.successful_cases = value.successful_cases || null;
        this.data.value.follow_up_of_patients =
          value.follow_up_of_patients || value["follow up_of_patients"] || null;
        this.data.value.degree_of_security = value?.degree_of_security || null;
        this.data.value.years_of_practice = value.years_of_practice || null;
        this.data.value.success_rate = value?.success_rate || null;
        this.data.value.about_title_ar = value.about_title_ar || null;
        this.data.value.about_title_en = value.about_title_en || null;
        this.data.value.about_description_ar =
          value.about_description_ar || null;
        this.data.value.about_description_en =
          value.about_description_en || null;
        this.data.value.youtube = value.youtube || null;
        this.data.value.facebook = value.facebook || null;
        this.data.value.instagram = value.instagram || null;
        this.data.value.tiktok = value.tiktok || null;
        this.data.value.linkedin =
          value.linkedin || value.linkedIn_link || null;
        this.data.value.whatsapp = value.whatsapp || null;
        this.data.value.spotify = value.spotify || null;
        this.data.value.site_url = value.site_url || null;
        this.data.value.google_tag_manager_id =
          value.google_tag_manager_id || null;
        this.data.value.seo_header_code = value.seo_header_code || null;
        this.data.value.tag_manager_head_code =
          value.tag_manager_head_code || null;
        this.data.value.tag_manager_body_code =
          value.tag_manager_body_code || null;
        this.data.value.robots_txt = value.robots_txt || null;
        this.data.value.sitemap_xml = value.sitemap_xml || null;
        this.data.value.sitemap_urls = value.sitemap_urls || null;
        this.data.value.doctor_page_ar = value.doctor_page_ar || null;
        this.data.value.doctor_page_en = value.doctor_page_en || null;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load dashboard settings"
        );
      }
    },

    validateFormInputs() {
      this.submitForm();
    },

    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "dashboard_setting");

      REQUEST_DATA.append(
        "value[header_title_ar]",
        this.data.value.header_title_ar || ""
      );
      REQUEST_DATA.append(
        "value[header_title_en]",
        this.data.value.header_title_en || ""
      );
      REQUEST_DATA.append(
        "value[header_description_ar]",
        this.data.value.header_description_ar || ""
      );
      REQUEST_DATA.append(
        "value[header_description_en]",
        this.data.value.header_description_en || ""
      );
      REQUEST_DATA.append(
        "value[year_experience]",
        this.data.value.year_experience || ""
      );
      REQUEST_DATA.append(
        "value[successful_cases]",
        this.data.value.successful_cases || ""
      );
      REQUEST_DATA.append(
        "value[follow_up_of_patients]",
        this.data.value.follow_up_of_patients || ""
      );
      REQUEST_DATA.append(
        "value[degree_of_security]",
        this.data.value.degree_of_security || ""
      );
      REQUEST_DATA.append(
        "value[years_of_practice]",
        this.data.value.years_of_practice || ""
      );
      REQUEST_DATA.append(
        "value[success_rate]",
        this.data.value.success_rate || ""
      );
      REQUEST_DATA.append(
        "value[about_title_ar]",
        this.data.value.about_title_ar || ""
      );
      REQUEST_DATA.append(
        "value[about_title_en]",
        this.data.value.about_title_en || ""
      );
      REQUEST_DATA.append(
        "value[about_description_ar]",
        this.data.value.about_description_ar || ""
      );
      REQUEST_DATA.append(
        "value[about_description_en]",
        this.data.value.about_description_en || ""
      );
      REQUEST_DATA.append("value[youtube]", this.data.value.youtube || "");
      REQUEST_DATA.append("value[facebook]", this.data.value.facebook || "");
      REQUEST_DATA.append("value[instagram]", this.data.value.instagram || "");
      REQUEST_DATA.append("value[tiktok]", this.data.value.tiktok || "");
      REQUEST_DATA.append("value[linkedin]", this.data.value.linkedin || "");
      REQUEST_DATA.append("value[whatsapp]", this.data.value.whatsapp || "");
      REQUEST_DATA.append("value[spotify]", this.data.value.spotify || "");
      REQUEST_DATA.append("value[site_url]", this.data.value.site_url || "");
      REQUEST_DATA.append(
        "value[google_tag_manager_id]",
        this.data.value.google_tag_manager_id || ""
      );
      REQUEST_DATA.append(
        "value[seo_header_code]",
        this.data.value.seo_header_code || ""
      );
      REQUEST_DATA.append(
        "value[tag_manager_head_code]",
        this.data.value.tag_manager_head_code || ""
      );
      REQUEST_DATA.append(
        "value[tag_manager_body_code]",
        this.data.value.tag_manager_body_code || ""
      );
      REQUEST_DATA.append(
        "value[robots_txt]",
        this.data.value.robots_txt || ""
      );
      REQUEST_DATA.append(
        "value[sitemap_xml]",
        this.data.value.sitemap_xml || ""
      );
      REQUEST_DATA.append(
        "value[sitemap_urls]",
        this.data.value.sitemap_urls || ""
      );
      REQUEST_DATA.append(
        "value[doctor_page_ar]",
        this.data.value.doctor_page_ar || ""
      );
      REQUEST_DATA.append(
        "value[doctor_page_en]",
        this.data.value.doctor_page_en || ""
      );

      if (this.data.header_image.file) {
        REQUEST_DATA.append("header_image", this.data.header_image.file);
      }
      if (this.data.about_image.file) {
        REQUEST_DATA.append("about_image", this.data.about_image.file);
      }

      try {
        await this.$axios.post("settings", REQUEST_DATA);
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to save dashboard settings"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },

  created() {
    this.getDataToEdit();
  },
};
</script>
